import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IUnitListBuilder } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';
import { IAction, IStateStrictV2 } from '@/shared/interfaces/store-base';
import { IModifyPayload } from '@/shared/interfaces/modify-payload';
import { adminRequest } from '@/shared/request-configs/admin-request';

const adminGatewayResourcePath: string = '/web-components-api/unit_list_builder'; // unit_list_builder
const cloneResourcePath: string = '/web-components-api/clone_unit_list_builder'; // clone_unit_list_builder
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [],
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [],
};

const base = new StoreBaseImplementationV2<IUnitListBuilder>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,

    /**
     * Saves an instance via the clone endpoint. The payload's `data.key` identifies the
     * source instance to clone; the BE looks it up and clones its relational data onto
     * the saved record.
    */
    cloneInstance: async (
      ctx: IAction<IStateStrictV2<IUnitListBuilder>>,
      payload: IModifyPayload<number, IUnitListBuilder>,
    ): Promise<IUnitListBuilder> => {
      const result = payload.id
        ? await adminRequest.put<IUnitListBuilder>(cloneResourcePath, payload.data)
        : await adminRequest.post<IUnitListBuilder>(cloneResourcePath, payload.data);

      const savedRecord = { ...payload.data, ...result.data } as IUnitListBuilder;

      ctx.commit('set', savedRecord);

      return savedRecord;
    },
  },
};
